import { createRouter,createWebHistory } from 'vue-router'
// import Login from '../views/Login.vue'

const routes = [
  // {
  //   path: '/',
  //   name: 'login',
  //   component: Login
  // },

  // AI对话
  {
    path: '/aiIndex',
    name: 'aiIndex',
    component: () => import('../views/ai/index.vue'),
  },


  // 首页
  {
    path: '/',
    name: 'main',
    component: () => import(/* webpackChunkName: "about" */ '../views/Index/Index.vue')
  },

  // 1+X
  {
    path: '/campusCenter',
    name: 'campusCenter',
    component: () => import('../views/campusCenter/index.vue'),
  },


  // 课程中心
  {
    path: '/courseCenter',
    name: 'courseCenter',
    component: () => import('../views/course/CourseCenter.vue'),
    redirect: '/courseCenter/courseList',
    children: [
      {
        path: '/courseCenter/courseList',
        name: 'courseList',
        component: () => import('../views/course/CourseList.vue'),
      },
      {
        path: '/courseCenter/courseDetail',
        name: 'courseDetail',
        component: () => import('../views/course/courseDetail.vue'),
      },
      {
        path: '/courseCenter/exam',
        name: 'exam',
        component: () => import('../views/course/exam.vue'),
      },
      {
        path: '/courseCenter/courseBlank',
        name: 'courseBlank',
        component: () => import('../views/course/CourseBlank.vue'),
      },
    ]
  },
  // 资源中心
  {
    path: '/resourceCenter',
    name: 'resourceCenter',
    component: () => import('../views/resource/ResourceCenter.vue'),
    redirect: '/resourceCenter/resourceList',
    children: [
      {
        path: '/resourceCenter/resourceList',
        name: 'resourceList',
        component: () => import('../views/resource/ResourceList.vue'),
      },
      {
        path: '/resourceCenter/resourceDetail',
        name: 'resourceDetail',
        component: () => import('../views/resource/ResourceDetail.vue'),
      },
    ]
  },
  // ai-历史记录
  {
    path: '/aiHistory',
    name: 'aiHistory',
    component: () => import('../views/course/aiHistory.vue'),
  },

  // 生成场景-历史记录
  {
    path: '/aiGenerateHistory',
    name: 'aiGenerateHistory',
    component: () => import('../views/resource/aiGenerateHistory.vue'),
  },

  
  // 竞赛中心

  // {
  //   path: '/contestCenter',
  //   name: 'contestCenter',
  //   component: () => import('../views/contest/ContestCenterNew.vue'),
  // },
  // {
  //   path: '/informationDetail',
  //   name: 'informationDetail',
  //   component: () => import('../views/contest/informationDetail.vue'),
  // },
  // {
  //   path: '/informationItemDetail',
  //   name: 'informationItemDetail',
  //   component: () => import('../views/contest/informationItemDetail.vue'),
  // },
  // {
  //   path: '/eventStyleDetail',
  //   name: 'eventStyleDetail',
  //   component: () => import('../views/contest/eventStyleDetail.vue'),
  // },
  // {
  //   path: '/eventStyleItemDetail',
  //   name: 'eventStyleItemDetail',
  //   component: () => import('../views/contest/eventStyleItemDetail.vue'),
  // },




  {
    path: '/contestCenter',
    name: 'contestCenter',
    component: () => import('../views/contest/ContestCenter.vue'),
  },
  {
    path: '/contestDetail',
    name: 'contestDetail',
    component: () => import('../views/contest/ContestDetail.vue'),
  },
  {
    path: '/contestEnroll',
    name: 'contestEnroll',
    component: () => import('../views/contest/ContestEnroll.vue'),
  },
  // 实训中心
  {
    path: '/trainCenter/:id',
    name: 'trainCenter',
    component: () => import('../views/train/TrainCenter.vue'),
  },
  {
    path: '/trainSoftDetail',
    name: 'trainSoftDetail',
    component: () => import('../views/train/TrainSoftDetail.vue'),
    redirect: '/trainSoftDetail/trainSoftIntroduce',
    children: [
      {
        path: '/trainSoftDetail/trainSoftIntroduce',
        name: 'trainSoftIntroduce',
        component: () => import('../views/train/TrainSoftIntroduce.vue'),
      },
      {
        path: '/trainSoftDetail/trainSoftCatalogue',
        name: 'trainSoftCatalogue',
        component: () => import('../views/train/TrainSoftCatalogue.vue'),
      },
      {
        path: '/trainSoftDetail/trainSoftTask',
        name: 'trainSoftTask',
        component: () => import('../views/train/TrainSoftTask.vue'),
      },{
        path: '/trainSoftDetail/trainSoftExamination',
        name: 'trainSoftExamination',
        component: () => import('../views/train/TrainSoftExamination.vue'),
      },
    ]
  },
  {
    path: '/trainEvaluateDetail',
    name: 'trainEvaluateDetail',
    component: () => import('../views/train/TrainEvaluateDetail.vue'),
    redirect: '/trainEvaluateDetail/trainEvaluateIntroduce',
    children: [
      {
        path: '/trainEvaluateDetail/trainEvaluateIntroduce',
        name: 'trainEvaluateIntroduce',
        component: () => import('../views/train/TrainEvaluateIntroduce.vue'),
      },
      {
        path: '/trainEvaluateDetail/trainEvaluateTask',
        name: 'trainEvaluateTask',
        component: () => import('../views/train/TrainEvaluateTask.vue'),
      },
    ]
  },
  {
    path: '/trainCaseDetail/:id',
    name: 'trainCaseDetail',
    component: () => import('../views/train/TrainCaseDetail.vue'),
  },
  // 人才评价
  {
    path: '/talentCenter',
    name: 'talentCenter',
    component: () => import('../views/TalentEvaluation/TalentCenter.vue'),
    redirect: '/talentCenter/postMap',
    children: [
      {
        path: '/talentCenter/postMap',
        name: 'postMap',
        component: () => import('../views/TalentEvaluation/PostMap.vue'),
      },
      {
        path: '/talentCenter/skillMap',
        name: 'skillMap',
        component: () => import('../views/TalentEvaluation/SkillMap.vue'),
      },
      {
        path: '/talentCenter/learningRecords',
        name: 'learningRecords',
        component: () => import('../views/TalentEvaluation/LearningRecords.vue'),
      },
      {
        path: '/talentCenter/softDetail',
        name: 'softDetail',
        component: () => import('../views/TalentEvaluation/softDetail.vue')
      },
      {
        path: '/talentCenter/postStatistics',
        name: 'postStatistics',
        component: () => import('../views/TalentEvaluation/postStatistics.vue')
      },
      {
        path: '/talentCenter/stuPersonnel',
        name: 'stuPersonnel',
        component: () => import('../views/TalentEvaluation/stuPersonnel.vue')
      }
    ]
  },
 
  // 个人中心
  {
    path: '/mineCenter/:index',
    name: 'mineCenter',
    component: () => import('../views/mine/MineCenter.vue'),
    children: [
      {
        path: '/mineCenter/minePersonnel/:index',
        name: 'minePersonnel',
        component: () => import('../views/mine/personnel/MinePersonnel.vue'),
        children: [
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelCourse',
            name: 'minePersonnelCourse',
            component: () => import('../views/mine/personnel/MinePersonnelCourse.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelCourseCollection',
            name: 'minePersonnelCourseCollection',
            component: () => import('../views/mine/personnel/MinePersonnelCourseCollection.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelResourceCollection',
            name: 'minePersonnelResourceCollection',
            component: () => import('../views/mine/personnel/MinePersonnelResourceCollection.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelExamMajor',
            name: 'minePersonnelExamMajor',
            component: () => import('../views/mine/personnel/MinePersonnelExamMajor.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelExamResult',
            name: 'minePersonnelExamResult',
            component: () => import('../views/mine/personnel/MinePersonnelExamResult.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelSimulationTraining',
            name: 'minePersonnelSimulationTraining',
            component: () => import('../views/mine/personnel/MinePersonnelSimulationTraining.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelIOTTraining',
            name: 'minePersonnelIOTTraining',
            component: () => import('../views/mine/personnel/MinePersonnelIOTTraining.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelSignIn',
            name: 'minePersonnelSignIn',
            component: () => import('../views/mine/personnel/minePersonnelSignIn.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelSettingInfo',
            name: 'minePersonnelSettingInfo',
            component: () => import('../views/mine/personnel/MinePersonnelSettingInfo.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/minePersonnelSettingAccount',
            name: 'minePersonnelSettingAccount',
            component: () => import('../views/mine/personnel/MinePersonnelSettingAccount.vue'),
          },
          {
            path: '/mineCenter/minePersonnel/:index/learningAnalysis',
            name: 'learningAnalysis',
            component: () => import('../views/mine/personnel/learningAnalysis.vue'),
          }
        ]
      },
      {
        path: '/mineCenter/mineClass',
        name: 'mineClass',
        component: () => import('../views/mine/class/MineClass.vue'),
      }
    ]
  },
  {
    path: '/minePersonnelExamMajorAnswer',
    name: 'minePersonnelExamMajorAnswer',
    component: () => import('../views/mine/personnel/MinePersonnelExamMajorAnswer.vue')
  },
  {
    path: '/mineClassCourseDetail',
    name: 'mineClassCourseDetail',
    component: () => import('../views/mine/class/MineClassCourseDetail.vue'),
    redirect: '/mineClassCourseDetail/mineClassCourseResult',
    children: [
      // {
      //   path: '/mineClassCourseDetail/mineClassCourseChapter',
      //   name: 'mineClassCourseChapter',
      //   component: () => import('../views/mine/class/MineClassCourseChapter.vue'),
      // },
      // {
      //   path: '/mineClassCourseDetail/mineClassCourseTesting',
      //   name: 'mineClassCourseTesting',
      //   component: () => import('../views/mine/class/MineClassCourseTesting.vue'),
      // },
      {
        path: '/mineClassCourseDetail/mineClassCourseResult',
        name: 'mineClassCourseResult',
        component: () => import('../views/mine/class/MineClassCourseResult.vue'),
      },
    ]
  },
  {
    path: '/mineClassCourseTestingQuestion/:id/:name/:courseName',
    name: 'mineClassCourseTestingQuestion',
    component: () => import('../views/mine/class/MineClassCourseTestingQuestion.vue'),
  },
  {
    path: '/mineClassInventDetail',
    name: 'mineClassInventDetail',
    component: () => import('../views/mine/class/MineClassInventDetail.vue'),
    redirect: '/mineClassInventDetail/mineClassInventIntroduce',
    children: [
      {
        path: '/mineClassInventDetail/mineClassInventIntroduce',
        name: 'mineClassInventIntroduce',
        component: () => import('../views/mine/class/MineClassInventIntroduce.vue'),
      },
      {
        path: '/mineClassInventDetail/mineClassInventCatalogue',
        name: 'mineClassInventCatalogue',
        component: () => import('../views/mine/class/MineClassInventCatalogue.vue'),
      },
      {
        path: '/mineClassInventDetail/mineClassInventLog',
        name: 'mineClassInventLog',
        component: () => import('../views/mine/class/MineClassInventLog.vue'),
      }
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.afterEach(()=>{
  window,scrollTo(0,0)
})
export default router
